export const usePromoModal = () => {
  const showModal = ref(false);
  const hasTriggered = ref(false);
  const modalId = ref();
  let lastScrollY = 0;
  let initialScrollHeight: number | null = null;

  const shouldShowModal = () => {
    if (hasTriggered.value || !import.meta.client) return false;
    // Only show the modal once a week
    const lastShown = localStorage.getItem(`promo_modal_${modalId.value}`);
    return !(lastShown && Date.now() - Number(lastShown) < 7 * 24 * 60 * 60 * 1000);
  };

  const checkScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY) {
      const baseHeight = initialScrollHeight ?? document.documentElement.scrollHeight;
      const scrollHeight = baseHeight - window.innerHeight;
      const scrollPercent = currentScrollY / scrollHeight;

      if (scrollPercent > 0.5 && shouldShowModal()) {
        showModal.value = true;
        hasTriggered.value = true;
        localStorage.setItem(`promo_modal_${modalId.value}`, Date.now().toString());
        window.removeEventListener('scroll', checkScroll);
      }
    }

    lastScrollY = currentScrollY;
  };

  const resetScrollTracking = () => {
    lastScrollY = 0;
    hasTriggered.value = false;
    initialScrollHeight = null;
    window.removeEventListener('scroll', checkScroll);
  };

  const startTracking = () => {
    if (shouldShowModal()) {
      initialScrollHeight = document.documentElement.scrollHeight;
      window.addEventListener('scroll', checkScroll, { passive: true });
    }
  };

  const closeModal = () => {
    showModal.value = false;
  };

  return {
    showModal,
    modalId,
    closeModal,
    startTracking,
    resetScrollTracking,
  };
};
